import { NotificationTypes } from 'enums/notificationTypes';
import Notification from 'shared/components/Notification';
import { FieldProps, RawMaterialProps } from 'enums/RawMaterialEnums';
import { defaultIngredientValue } from '../defaultValue';
import { FormikProps } from 'formik';
import { Origin, rawMaterialPayload } from 'views/CreateProductFlow/CreateProductFlowInterfaces';
import React from 'react';
import { ReactComponent as Add } from 'assets/icons/add.svg';

// Add type for CSS module
type Styles = {
  readonly [key: string]: string;
};

export const handleIngredientOnChange = (
  value: string,
  index: number,
  formikProps: FormikProps<rawMaterialPayload>
) => {
  const ingredients = formikProps.values.ingredients;
  const selectedIngredient = ingredients.find(
    item => item.ingredientName === value
  );
  if (selectedIngredient) {
    Notification({
      message: 'Ingredient already exists, please add another sub-origin',
      description: '',
      type: NotificationTypes.ERROR,
    });
    return null;
  }
  formikProps.setFieldValue(
    `${RawMaterialProps.INGREDIENTS}.['${index}']`,
    {
      ...defaultIngredientValue,
      ingredientName: value,
      ingredientQuantity:
        formikProps.values.ingredients[index]?.ingredientQuantity ?? '',
      ingredientUnit:
        formikProps.values.ingredients[index]?.ingredientUnit ?? undefined,
    },
    true
  );
};

export const onOriginClick = (
  index: number,
  isDisabled: boolean,
  formikProps: FormikProps<rawMaterialPayload>,
  showLocationModal: (
    index: number,
    type: string,
    selectedIndexData?: Origin[],
    selectedRecordIndex?: number,
    selectedRecordType?: string
  ) => void
) => {
  if (isDisabled) return true;

  const dataObj = [
    {
      address: formikProps?.values?.ingredients?.[index]?.address,
      bestfitRegion:
        formikProps?.values?.ingredients?.[index]?.bestFitProductionRegion,
      ingredientOrigin:
        formikProps?.values?.ingredients?.[index]?.ingredientOrigin,
      id: formikProps?.values?.ingredients?.[index]?.id,
      originShare: undefined,
      percentage: '%',
    },
  ];
  showLocationModal(
    index,
    RawMaterialProps.INGREDIENTS,
    dataObj,
    index,
    RawMaterialProps.INGREDIENTS
  );
};

export const ingredientMenu = (
  menu: React.ReactNode,
  handleOpenRequestIngredientModal: () => void,
  styles: Styles
) => (
  <>
    <div
      className={styles.dropdownCreateButton}
      onClick={handleOpenRequestIngredientModal}>
      <Add /> {FieldProps.REQUEST_INGREDIENT}
    </div>
    {menu}
  </>
);

export const fieldDisabled = (
  index: number,
  isDisabled: boolean,
  formikProps: FormikProps<rawMaterialPayload>
) =>
  isDisabled || formikProps.values.ingredients[index].origins?.length
    ? true
    : false;
